/*
 * this component is a workaround for 1Password extension compatibility issue.
 * this component must be the target of the onMouseDown event,
 * otherwise, 1Password extension will intercept the event and break the user gesture chain,
 * preventing our side panel from opening
 *
 * Problem:
 * - 1Password extension intercepts onMouseDown events on most elements (except input/textarea)
 * - it checks composedPath()[0] for the event target, if it is an input/textarea, it will not intercept
 * - When intercepted, it sends a message to its background process
 * - This breaks the user gesture chain, preventing our side panel from opening
 *
 * Solution:
 * - Add an invisible input element inside the button to prevent 1Password from intercepting onMouseDown events
 * - The input is:
 *   - Invisible (opacity: 0)
 *   - Not tabbable (tabIndex: -1)
 *   - Covers the entire button (position: absolute, inset: 0)
 *   - Maintains cursor style (cursor: inherit)
 *
 * This preserves the original button behavior while avoiding 1Password's event interception.
 */
export const OnePasswordExtensionBypass = () => (
  <input
    aria-hidden="true"
    tabIndex={-1}
    style={{
      position: 'absolute',
      inset: 0,
      opacity: 0,
      cursor: 'inherit',
    }}
  />
)
